<template>
    <flex-element :tag="renderTag" :element-type="elementType" class="f-flex">
        <component
            :is="element.elementType"
            v-for="(element, index) in elementsNew"
            :key="element.id"
            :pointer="index + 1"
            :index="index"
            v-bind="element"
            @element-updated="elementUpdated"
            @submit-form="submitForm"
        />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';

export default {
    name: 'drop-zone-single',
    mixins: [baseOrganism],

    props: {
        idOverride: {
            type: String,
            default: '',
        },

        tag: {
            type: String,
            default: '',
        },

        tagDefault: {
            type: String,
            default: 'div',
        },

        text: {
            type: String,
            default: '',
        },

        theme: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            elementsOriginalLength: 0,
            valueNew: '',
            tagNew: '',
            idOverrideNew: '',
        };
    },

    computed: {
        listeners() {
            return this.$listeners;
        },

        renderTag() {
            return this.tagNew || this.tagDefault;
        },
    },

    beforeMount() {
        this.setFieldValues();
    },

    methods: {
        setFieldValues() {
            this.idOverrideNew = this.idOverride;
            this.tagNew = this.tag;

            if (this.elements) {
                this.elementsOriginalLength = this.elements.length;
            }
        },

        submitForm() {
            this.$emit('submit-form');
        },
    },
};
</script>
